import { useExecuteDisbursement } from '@/hooks/disbursement/useExecuteDisbursement';
import { useGetBalance } from '@/hooks/disbursement/useGetBalance';

export function useDisbursementViewController() {
  const executeDisbursementHook = useExecuteDisbursement();
  const getBalanceHook = useGetBalance();

  const onMoreActionClicked = (index: number) => {
    if (index === 0) executeDisbursement();
  };

  const executeDisbursement = () => {
    const amount = getBalanceHook.data?.available;
    if (amount === undefined) return;
    executeDisbursementHook.executeDisbusement(amount);
  };

  return {
    actions: {
      onMoreActionClicked,
    },
  };
}
